<template>
  <div class="shadow-lg mark-as-complete-wrapper section-bg-color p-6 rounded-lg">
    <div class="text-3xl font-bold mb-3 section-heading-color">
      <slot name="title"></slot>
    </div>
    <slot name="button"></slot>
    <div
      class="
        flex
        items-center
        justify-between
        mt-8
        section-content-color
        next-lesson-tile-wrapper-t2
      "
    >
      <slot name="next-or-previous-lesson"></slot>
    </div>
    <div class="flex justify-between w-full section-content-color">
      <slot name="next-or-previous-buttons"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MarkAsComplete',
  props: {
    getThemeSettings: {},
  },
  computed: {
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-section-bg-color':
          this.themeSettings.configuration_options.section_bg_color,
        '--template-section-heading-color':
          this.themeSettings.configuration_options.section_heading_color,
        '--template-section-content-color':
          this.themeSettings.configuration_options.section_content_color,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.section-bg-color {
  background-color: var(--template-section-bg-color);
}
.section-heading-color {
  color: var(--template-section-heading-color);
}
.section-content-color {
  color: var(--template-section-content-color);
}
</style>
<style lang="scss">
.tablet-template,
.mobile-template {
  .mark-as-complete-wrapper {
    .next-lesson-tile-wrapper-t2 {
      padding-right: 0px;
      padding-bottom: 8px;
      margin-top: 40px;
      > div {
        width: 100%;
      }
      .flex {
        flex-direction: column;
        padding-bottom: 0px;
        .mr-4 {
          margin-right: 0px;
        }
        img {
          width: 100%;
          margin-bottom: 15px;
          height: 100px;
        }
        .text-md {
          margin-bottom: 0px;
        }
      }
    }
  }
}
@media only screen and (max-width:767px){
  .mark-as-complete-wrapper {
    .next-lesson-tile-wrapper-t2 {
      padding-right: 0px;
      padding-bottom: 8px;
      margin-top: 40px;
      > div {
        width: 100%;
      }
      .flex {
        flex-direction: column;
        padding-bottom: 0px;
        .mr-4 {
          margin-right: 0px;
        }
        img {
          width: 100%;
          margin-bottom: 15px;
          height: 100px;
        }
        .text-md {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>